export default __webpack_public_path__ + "static/media/Tarek.e2790d58.jpeg";